import achievements from './achievements'
import administrators from './administrators'
import affiliations from './affiliations'
import applications from './applications'
import candidates from './candidates'
import campaigns from './campaigns'
import clients from './clients'
import documentBundles from './document_bundles'
import disciplines from './disciplines'
import eligibilities from './eligibilities'
import experiences from './experiences'
import experience_organizations from './experience_organizations'
import feedbackRequests from './feedback_requests'
import flags from './flags'
import householdIncome from './household_incomes'
import financialAssessment from './financial_assessments'
import institutions from './institutions'
import invites from './invites'
import jobs from './jobs'
import languageProficiencies from './language_proficiencies'
import organizations from './organizations'
import opportunities from './opportunities'
import profiles from './profiles'
import profileQualifications from './profile_qualifications'
import profileQualificationComponents from './profile_qualification_components'
import qualifications from './qualifications'
import qualificationComponents from './qualification_components'
import qualificationTypes from './qualification_types'
import referrals from './referrals'
import studyRights from './study_rights'
import supervisors from './supervisors'
import workRights from './work_rights'

export default {
  namespaced: true,
  modules: {
    achievements,
    administrators,
    affiliations,
    applications,
    candidates,
    campaigns,
    clients,
    disciplines,
    documentBundles,
    eligibilities,
    experiences,
    experience_organizations,
    feedbackRequests,
    flags,
    householdIncome,
    financialAssessment,
    institutions,
    invites,
    jobs,
    languageProficiencies,
    organizations,
    opportunities,
    profiles,
    profileQualifications,
    profileQualificationComponents,
    qualifications,
    qualificationComponents,
    qualificationTypes,
    referrals,
    studyRights,
    supervisors,
    workRights,
  },
}
